import React from 'react';

import PropTypes from 'prop-types';

import { Text, TextGroup, Title } from '@asteria/component-core/typography';

import { Translation } from '@asteria/language';

import './styles.scss';

/**
 * @typedef { import('./types').Props } Props
 * @typedef { import('./types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<ChildrenProps> } */
const Splash = React.memo(function Splash(props) {
	const { query } = props;

	const type = query?.data?.type;

	const translationOptions = React.useMemo(
		() => ({ data: { data: query?.data } }),
		[query?.data],
	);

	const loading = query?.isFetching;

	return (
		<TextGroup className="flex flex-col gap-2">
			<Translation
				translationKey="transaction.details.sidebar.content.overview.label"
				translationOptions={translationOptions}
				Component={Text}
				align="center"
				size="sm"
				loading={loading}
			/>
			<Translation
				translationKey={[
					'transaction.details.sidebar.content.overview.amount',
					`transaction.details.sidebar.content.overview.amount.${type}`,
				]}
				defaultText="{{ data.sums.display.total | number }} {{ data.sums.display.currency }}"
				translationOptions={translationOptions}
				Component={Title}
				align="center"
				loading={loading}
			/>
			<Translation
				translationKey="transaction.details.sidebar.content.overview.date"
				translationOptions={translationOptions}
				Component={Text}
				align="center"
				size="sm"
				loading={loading}
			/>
		</TextGroup>
	);
});

Splash.propTypes = {
	query: PropTypes.object,
};

export default Splash;
